export default __webpack_public_path__ + "static/media/PrePurchaseInspectionBlue.3fee20df.svg";